import React from "react";
import { handleDay } from "@/utils/helper";
import { Input, Select, Option } from "@material-tailwind/react";
import { AiOutlineSearch } from "react-icons/ai";

interface Props {
  startDate: string;
  endDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
  onChangeFunc: (value: string) => void;
  nameInput: string;
  dataInput: string;
  placeHolder: string;
  searchFunc: () => void;
  options?: { value: string; label: string }[];
}

const SearchSuperVoucherComponents: React.FC<Props> = ({
  endDate,
  setEndDate,
  startDate,
  setStartDate,
  nameInput,
  onChangeFunc,
  dataInput,
  placeHolder,
  searchFunc,
  options = [],
}: Props) => {
  return (
    <div className="list-query">
      <div className="list-query__search w-1/4">
        <p className="text-sm">{nameInput}</p>
        <Select
          variant="standard"
          color="gray"
          value={dataInput}
          onChange={(value) => value && onChangeFunc(value)}
          className="truncate-select"
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </div>
      <div className="list-query__search w-1/4">
        <p className="text-sm">Từ Ngày</p>
        <Input
          variant="static"
          color="gray"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(handleDay(e.target.value))}
        />
      </div>
      <div className="list-query__search w-1/4">
        <p className="text-sm">Đến Ngày</p>
        <Input
          variant="static"
          color="gray"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(handleDay(e.target.value))}
        />
      </div>
      <div className="list-query__search flex justify-center">
        <button className="check-another-activated" onClick={searchFunc}>
          <AiOutlineSearch />
          <span>Tìm Kiếm</span>
        </button>
      </div>
    </div>
  );
};

export default SearchSuperVoucherComponents;
